export default __webpack_public_path__ + "static/media/frame-card-warrior.eace8b41.png";